import styled from 'styled-components';
import { Text } from '@rsos/base-components';

export const SoundControlTitle = styled(Text).attrs({
  size: 'header',
  fontWeight: 'semibold',
  mb: '8px',
  color: 'primaryText',
})``;

export const SoundControlDescription = styled(Text).attrs({
  size: 'normal',
  mb: 20,
  color: 'primaryText',
})``;
